<script>
import dateMixin from '../../mixins/dateMixin';
import XmlChannelStatusCardHeader from './XmlChannelStatusCardHeader';

export default {
  name: 'XmlChannelStatusCvCard',
  components: {
    XmlChannelStatusCardHeader,
  },
  mixins: [
    dateMixin,
  ],
  props: {
    xmlChannel: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openJobList(xmlChannel) {
      this.$emit('open-job-list', xmlChannel);
    },
  },
};
</script>

<template>
  <v-flex v-if="xmlChannel.latestJob">
    <xml-channel-status-card-header :xml-channel="xmlChannel"/>
    <v-divider class="mx-2"/>
    <v-card-text class="title">
      {{ $t('xmlChannelStatus.xmlChannelStatusCard.latestJob') }}
    </v-card-text>
    <v-card-text class="pt-0 pb-1">
      <span>
        <strong>{{ $t('xmlChannelStatus.xmlChannelStatusCard.receivedUpdates') }}:</strong>
      </span>
      <span>
        {{ xmlChannel.latestJob.updates }}
      </span>
    </v-card-text>
    <v-card-text class="pt-0 pb-1">
      <span>
        <strong>{{ $t('xmlChannelStatus.xmlChannelStatusCard.importStarted') }}:</strong>
      </span>
      <span>{{ formatDate(xmlChannel.latestJob.messageStart) }}</span>
    </v-card-text>
    <v-card-text class="pt-0 pb-1">
      <span>
        <strong>{{ $t('xmlChannelStatus.xmlChannelStatusCard.syncStarted') }}:</strong>
      </span>
      <span v-if="xmlChannel.latestJob.updateStart">
        {{ formatDate(xmlChannel.latestJob.updateStart) }}
      </span>
      <span v-else class="pl-2">-</span>
    </v-card-text>
    <v-divider class="mx-2 pt-1"></v-divider>
    <v-btn @click="openJobList(xmlChannel)" color="primary" disabled outline>
      {{ $t('xmlChannelStatus.xmlChannelStatusCard.productList') }}
    </v-btn>
  </v-flex>
  <v-flex v-else>
    <v-card-title dark>
      {{ xmlChannel.webservice }}
      <v-spacer />
      <small>{{ xmlChannel.system }}</small>
      <v-spacer />
      <badge :badge="badges['NO_CONTENT']"/>
    </v-card-title>
  </v-flex>
</template>



// WEBPACK FOOTER //
// src/components/xmlChannelStatus/XmlChannelStatusCVCard.vue